export default class PriceHelper {
    static getPeopleCount(parameters) {
        let people = 0;
        people += parameters.adults ? parseInt(parameters.adults, 10) : 0;
        people += parameters.children ? parseInt(parameters.children, 10) : 0;
        people += parameters.infants ? parseInt(parameters.infants, 10) : 0;

        return people;
    }

    static getFlightPrice(parameters, generalPrice) {
        return generalPrice / PriceHelper.getPeopleCount(parameters);
    }
}



// WEBPACK FOOTER //
// ./src/helpers/PriceHelper.js